import { render, staticRenderFns } from "./AppSumo.vue?vue&type=template&id=61d8db95"
import script from "./AppSumo.vue?vue&type=script&lang=js"
export * from "./AppSumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports